import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var dropdownMenuComponentName = 'QuantumDropdownMenu';
export function getDropdownMenuUtilityClass(slot) {
    return generateUtilityClass(dropdownMenuComponentName, slot);
}
export var dropdownMenuClasses = generateUtilityClasses(dropdownMenuComponentName, ['root', 'paper']);
